export default __webpack_public_path__ + "static/media/double-single-border-both.b841e674.svg";